//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async asyncData ({ store, params }) {
    try {
      const resp = await store.dispatch('axios/get', {
        url: '/academy/post/news/' + params.id,
        config: {
          baseURL: process.env.ASYNC_BASE_URL_API
        }
      })

      return {
        news: resp.data.data
      }
    } catch (error) {
      console.error('خطا در دریافت خبر:', error)

      return {
        news: null
      }
    }
  },

  data () {
    return {
      news: null
    }
  },

  methods: {
    formatDate (date) {
      if (!date) {
        return ''
      }

      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(new Date(date))
    }
  }
}
